import { render, staticRenderFns } from "./AdminOrdersEditScreen.vue?vue&type=template&id=689e5442&scoped=true&"
import script from "./AdminOrdersEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminOrdersEditScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrdersEditScreen.vue?vue&type=style&index=0&id=689e5442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e5442",
  null
  
)

export default component.exports